import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { getWelcomeInformation, hideWelcomeWindow, updateInformationTextRead } from 'actions/information_texts';
import Modal from 'containers/Modals/Modal';
import { Checkbox } from '@haldor/ui';

var WelcomeMessage = function WelcomeMessage(props) {
  var translate = useTranslate();
  var dispatch = useDispatch();
  var message = useSelector(function (state) {
    return state.InformationTexts.welcome;
  });
  var hideWelcomeModal = useSelector(function (state) {
    return state.InformationTexts.hideWelcomeModal;
  });
  var user = useSelector(function (state) {
    return state.user.currentUser;
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      disabled = _useState4[0],
      setDisabled = _useState4[1];

  useEffect(function () {
    if (hideWelcomeModal) {
      setOpen(false);
      return;
    }

    dispatch(getWelcomeInformation());
  }, []);

  var onClose = function onClose() {
    setOpen(false);

    if (!disabled) {
      dispatch(hideWelcomeWindow());
      return;
    }

    dispatch(updateInformationTextRead({
      "referenceType": 'INFORMATIONTEXT',
      "referenceId": message.id,
      "userType": 'USER',
      "status": disabled ? 'DONTSHOWAGAIN' : null
    }));
  };

  var onCheckboxChange = function onCheckboxChange(checked) {
    setDisabled(checked);
  };

  if (message == null) {
    return null;
  }

  if (message.parts == null || message.parts.length == 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Modal, {
    type: "small news",
    overridePrompt: true,
    onClose: onClose,
    isOpen: open
  }, /*#__PURE__*/React.createElement("div", {
    className: "form",
    style: {
      paddingBottom: '3rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, message.parts != null ? message.parts.map(function (part, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: 'part' + index,
      dangerouslySetInnerHTML: {
        __html: translate(part, user.firstName)
      }
    });
  }) : null, message.showType == 'USERSET' ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '2rem'
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onCheckboxChange,
    value: disabled,
    label: translate('Do not show this message again')
  })) : null)));
};

export default WelcomeMessage;